import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const SCROLL_SHOW_THRESHOLD_PX = 120;

function pageIsScrollable() {
  const doc = document.documentElement;
  return doc.scrollHeight > window.innerHeight + 1;
}

function topIsHidden() {
  return window.scrollY > SCROLL_SHOW_THRESHOLD_PX;
}

export default function ScrollToTopButton() {
  const { t } = useTranslation();
  const location = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const update = () => {
      setVisible(pageIsScrollable() && topIsHidden());
    };

    update();
    const raf = window.requestAnimationFrame(update);
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    return () => {
      window.cancelAnimationFrame(raf);
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, [location.pathname]);

  if (!visible) {
    return null;
  }

  return (
    <button
      type="button"
      className="scroll-to-top"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      title={t('scrollToTop')}
      aria-label={t('scrollToTop')}
    >
      <span className="oi oi-chevron-top" aria-hidden="true" />
    </button>
  );
}
